import { Action } from 'redux';

import ActionPayloadNumber from '../interfaces/actions/ActionPayloadNumber';
import ActionPayloadString from '../interfaces/actions/ActionPayloadString';
import ActionSetCurrentSnapTile from '../interfaces/actions/ActionSetCurrentSnapTile';

import * as Const from '../constants';

export const setMapFieldInit = (): Action => {
  return {
    type: Const.FETCH_MAP_FIELD_INIT,
  };
};

export const setMapFieldPending = (): Action => {
  return {
    type: Const.FETCH_MAP_FIELD_PENDING,
  };
};

export const fetchMapFieldSuccess = (id: string | number, payload: any) => {
  return {
    type: Const.FETCH_MAP_FIELD_SUCCESS,
    payload,
    id,
  };
};

export const setMapFieldError = (): Action => {
  return {
    type: Const.FETCH_MAP_FIELD_ERROR,
  };
};

export const setUserId = (payload: string): ActionPayloadString => {
  return {
    type: Const.FETCH_MAP_FIELD_USER_ID,
    payload,
  };
};

export const setFieldId = (payload: number): ActionPayloadNumber => {
  return {
    type: Const.CURRENT_MAP_FIELD_ID,
    payload,
  };
};

export const setCurrentSnapTile = (snap: any): ActionSetCurrentSnapTile => {
  return {
    type: Const.SET_CURRENT_SNAP_TILE,
    snap,
  };
};
